import React from 'react';
import { connect } from 'react-redux';
import { withLocalize } from "react-localize-redux";
import { bindActionCreators } from 'redux';
import { reportActions } from '../../../store/reportStore';
import AmlCompanyEval from './amlCompanyEval';
import AmlStatutoriesEval from './amlStatutoriesEval';
import AmlKeyOwnersEval from './amlKeyOwnersEval';
import AmlBeneficialOwnersEval from './amlBeneficialOwnersEval';
import AmlFinalOwnersEval from './amlFinalOwnersEval';
import AmlSupervisoryBoardEval from './amlSupervisoryBoardEval';
import AmlPublicFunctionsEval from './amlPublicFunctionsEval';

class AmlRelatedSubjectsEval extends React.Component {
    state = { expanded: false, isExpandedTouched: false };

    componentDidUpdate(prevProps) {
        if (this.props.isExpandAllActivated !== prevProps.isExpandAllActivated || this.props.isHideAllActivated !== prevProps.isHideAllActivated) {
            this.setState({ isExpandedTouched: false });
        }
    }

    toggleContent = () => {
        this.setState(state => ({
            expanded: !this.props.resolveExpanded(state.expanded, state.isExpandedTouched),
            isExpandedTouched: true
        }));
    }

    render() {
        return (
            <>
                <AmlCompanyEval data={this.props.subjects.company} section="company" hideRatioFilter={this.props.hideRatioFilter}/>
                <AmlStatutoriesEval data={this.props.subjects.statutories} section="statutories" hideRatioFilter={this.props.hideRatioFilter}/>
                <AmlKeyOwnersEval data={this.props.subjects.keyOwners} section="keyOwners" hideRatioFilter={this.props.hideRatioFilter}/>
                <AmlBeneficialOwnersEval finalOwnerNegativeInfoText={this.props.finalOwnerNegativeInfoText} data={this.props.subjects.beneficialOwners} section="beneficialOwners" hideRatioFilter={this.props.hideRatioFilter}/>
                <AmlFinalOwnersEval data={this.props.subjects.finalOwners} methodology={this.props.methodology} share={this.props.share} section="finalOwners" hideRatioFilter={this.props.hideRatioFilter}/>
                {this.props.profiles.includes("B") &&<AmlSupervisoryBoardEval data={this.props.subjects.supervisoryBoard} methodology={this.props.methodology} share={this.props.share} section="supervisoryBoard" hideRatioFilter={this.props.hideRatioFilter}/>}
                {this.props.profiles.includes("P") && <AmlPublicFunctionsEval data={this.props.subjects.publicFunctions} methodology={this.props.methodology} share={this.props.share} section="publicFunctionsEval" hideRatioFilter={this.props.hideRatioFilter}/>}
            </>
        );
    }
}

export default withLocalize(connect(
    state => state.report,
    dispatch => bindActionCreators(reportActions, dispatch)
)(AmlRelatedSubjectsEval));